import { createContext, useContext, useState, useEffect } from "react";
import config from "../config";
import API from "../utils/API";


const alluserContextDefaultValues = {
  filters: {},
  defaultFilters: {},
  filterData: {},
  inputs: {},
  storeFilters: () => {},
  storeFilterData: () => {},
  storeInputs: () => {},
};

const AlluserContext = createContext(alluserContextDefaultValues);

export function AlluserProvider({ children }) {
  let userData = window.$user_profile;
  const defaultFilters = {
    country: [
      userData.is_exo_group === "yes" ? "EXOGROUP" : userData.employed_by_code,
    ],
    active: "Y",
    limit: 10,
    page: 1,
    keyChange: 0,
    key_form: 0,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [filterData, setFilterData] = useState({
    status: "",
    data: "",
    err: 0,
    err_msg: "",
  });
  const [inputs, setInputs] = useState({
    selectedExportSheet: "all",
    selectedFields: [],
  });

  useEffect(() => {
    const mainFunc = async () =>
      await API.post("alluser/filter", {
        params: ({
          country_name: userData.employed_by,
          organizations: userData?.user_org ?? [],
          is_access_all_country: userData.user_sess.userCanAccessAllCountries,
          is_exo_group: userData.is_exo_group,
          userID: userData.idu,
        }),
      });
    mainFunc()
      .then((res) => {
        const decrypt = (res?.data);
        // console.log("alluser filter=>", decrypt);
        if (decrypt?.status === "success" && decrypt?.data) {
          if (decrypt?.data?.columns) {
            const columnObjs = {};
            for (const item of decrypt.data.columns) {
              columnObjs[item.name] = item;
            }
            decrypt.data.columnObjs = columnObjs;
          }
          setFilters({
            ...filters,
            country: decrypt?.data?.org_country_codes ?? [],
          });
          setInputs({
            ...inputs,
            selectedFields: decrypt?.data?.userFields ?? [],
          });
          setFilterData(decrypt.data);
        } else {
          setInputs({ ...inputs, selectedFields: [] });
          setFilterData({
            err: 1,
            err_msg: `Failes : ${decrypt?.err_msg ?? ""}`,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setInputs({ ...inputs, selectedFields: [] });
        setFilterData({ err: 1, err_msg: `Failes : ${err}` });
      });
  }, []);

  const storeFilters = (data) => {
    setFilters(data);
  };

  const storeFilterData = (data) => {
    setFilterData(data);
  };

  const storeInputs = (data) => {
    setInputs(data);
  };

  const value = {
    filters: filters,
    defaultFilters: defaultFilters,
    filterData: filterData,
    inputs: inputs,
    storeFilters: storeFilters,
    storeFilterData: storeFilterData,
    storeInputs: storeInputs,
  };

  return (
    <AlluserContext.Provider value={value}>{children}</AlluserContext.Provider>
  );
}

export const useAlluser = () => useContext(AlluserContext);

